import { EndpointCallParams } from '@core/api/endpointCallParams';

import { IApiStore } from '@core/api/apiStore';

export type ResolveExecutionMediaParams = {
  ExecutionId: string,
  MediaUrl: string,
};

const RESOLVED_URL_KEYS = [
    'url', 'Url',
    'mediaUrl', 'MediaUrl',
    'resolvedUrl', 'ResolvedUrl',
    'preSignedUrl', 'PreSignedUrl', 'presignedUrl', 'PresignedUrl',
    'signedUrl', 'SignedUrl',
];

export function extractResolvedMediaUrl(data: unknown): string | null {
    if (typeof data === 'string' && data.trim()) {
        return data;
    }

    if (data && typeof data === 'object' && !Array.isArray(data)) {
        for (const key of RESOLVED_URL_KEYS) {
            const value = (data as Record<string, unknown>)[key];

            if (typeof value === 'string' && value.trim()) {
                return value;
            }
        }
    }

    return null;
}

export const performResolveExecutionMedia = async (api: IApiStore, params: EndpointCallParams<ResolveExecutionMediaParams>) => {
    const { payload, ...rest } = params;
    const req = api
        .post('contentfileprovider-app/api/v1/ExecutionMedia/resolve', {
            ...rest,
            payload: { ...payload },
        })

    return req;
}
